<div class="container-fluid">
  <div class="d-flex flex-row justify-content-between mb-4">

    <div class="d-flex position-relative w-100" style="max-width: 300px;">
      <input type="text" id="search-description" class="form-control form-control-sm pe-5"
        placeholder="Search by job description" [(ngModel)]="searchText" (keyup)="searchByDescriptionEvent($event)">

      <i *ngIf="!searchText" class="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
        (click)="triggerSearch()"></i>

      <i *ngIf="searchText"
        class="bi bi-x position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
        (click)="clearSearch()"></i>
    </div>

    <div>
      <button class="btn btn-secondary text-white" type="button" (click)="exportCsv()" aria-label="Export transactions as CSV">
        Export as CSV<i class="bi bi-file-earmark-arrow-down ms-2"></i>
      </button>
    </div>
  </div>

  <ag-grid-angular class="ag-theme-alpine w-100" style="height: 500px;" [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
  </ag-grid-angular>

</div>